import { getColorValue } from './get-color-value.js';
import { getDefaultValue } from './get-default-value.js';
import { getFontSizeValue } from './get-font-size-value.js';
import { getSpacingValue } from './get-spacing-value.js';

const valueGetters = {
  color: getColorValue,
  default: getDefaultValue,
  fontSize: getFontSizeValue,
  spacing: getSpacingValue
};

export { valueGetters };
//# sourceMappingURL=value-getters.js.map
